import { useCallback } from "react";

export const useUomFieldUpdater = ({
    fieldMapping,
    sourceData,
    conversation_factor,
    fieldPrefix = 'item_entries',
    setValue,
    shouldUpdate = true,
    active_location,
}: {
    fieldMapping: Record<string, string>;
    sourceData: any;
    conversation_factor?: number | string;
    fieldPrefix: string;
    setValue: any;
    shouldUpdate: boolean;
    active_location?: any;
}) => {

    return useCallback(() => {
        if (!shouldUpdate || !sourceData) return;

        Object.entries(fieldMapping).forEach(([sourceKey, targetKey]) => {
            
            const sourceValue = sourceData[sourceKey];
            const factor = Number(conversation_factor) || 1;

            const fieldPath = fieldPrefix
                ? `${fieldPrefix}.${targetKey}`
                : targetKey;
            
            let convertedValue;

            // If active_location is null, set value to 0
            if (active_location === null) {
                convertedValue = 0;
            } else if (active_location && typeof active_location === 'object' && sourceData?.location_wise_quantity) {
                // Find location from array where active_location.id = location_id
                const location_quantity = sourceData.location_wise_quantity.find((item: any) => item.location_id === active_location.id);
                if (location_quantity) {
                    // Use location-specific values
                    switch(sourceKey) {
                        case 'total_on_hand_quantity':
                            const totalOnHand = (location_quantity.total_available_quantity - location_quantity.total_reserved_quantity);
                            convertedValue = totalOnHand > 0 ? totalOnHand / factor : 0;
                            break;
                        case 'total_available_quantity':
                            convertedValue = location_quantity.total_available_quantity / factor;
                            break;
                        case 'total_committed_quantity':
                            convertedValue = location_quantity.total_committed_quantity / factor;
                            break;
                        default:
                            convertedValue = (sourceKey == 'sales_price' || sourceKey == 'rental_base_price' || sourceKey == 'cost') 
                                ? factor !== 0 ? (Number(sourceValue) * factor) || 0 : 0 
                                : factor !== 0 ? (Number(location_quantity[sourceKey]) / factor) || 0 : 0;
                    }
                } else {
                    // Location not found, use 0
                    convertedValue = 0;
                }
            } else {
                // Default conversion logic
                convertedValue = (sourceKey == 'sales_price' || sourceKey == 'rental_base_price' || sourceKey == 'cost') 
                    ? factor !== 0 ? (Number(sourceValue) * factor) || 0 : 0 
                    : factor !== 0 ? (Number(sourceValue) / factor) || 0 : 0;
            }

            setValue(fieldPath, convertedValue);
        });
    }, [fieldMapping, sourceData, conversation_factor, fieldPrefix, setValue, shouldUpdate, active_location]);
};

